import React from 'react';
import PersonalInfo from './PersonalInfo';
import ShopInfo from './ShopInfo';

const EditInformation = () => {

    return (
        <div className="editInfo">
            <div className="contain">

                <PersonalInfo />
                {/* <ShopInfo /> */}

            </div>
        </div>
    );
}

export default EditInformation;